"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeInterfaceName = exports.formatTime = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.function.name.js");
require("antd/lib/date-picker/style");
var _timePicker = _interopRequireDefault(require("antd/lib/time-picker"));
var _en_US = _interopRequireDefault(require("antd/lib/date-picker/locale/en_US"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var _formElements = require("@evidation/form-elements");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var timeInterfaceName = exports.timeInterfaceName = "time (24-hour clock)";
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "time__Wrapper"
})([":first-child,.ant-time-picker{width:135px;input.ant-time-picker-input{:disabled{cursor:default;color:inherit;opacity:0.5;}}}"]);
var asterisk = (0, _styledComponents.css)(["content:'* ';"]);
var Label = _styledComponents["default"].label.withConfig({
  displayName: "time__Label"
})(["p:first-child:before{", "}"], function (p) {
  return p.required && asterisk;
});
var formatTime = exports.formatTime = function formatTime(inputVal, format) {
  if (inputVal) {
    //Test to see if the input string is valid datetime then parse to 24 hour time if it is
    var time = !_lodash["default"].isNaN(Date.parse(inputVal)) ? (0, _moment["default"])(inputVal).format(format) : inputVal;
    return (0, _moment["default"])(time, format);
  }
  return null;
};
var Time = /*#__PURE__*/function (_React$Component) {
  function Time() {
    var _this;
    (0, _classCallCheck2["default"])(this, Time);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Time, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      open: false,
      value: null
    });
    (0, _defineProperty2["default"])(_this, "handleOpenChange", function (open) {
      if (open) _this.props.input.onFocus();else _this.props.input.onBlur();
      _this.setState({
        open: open
      });
    });
    (0, _defineProperty2["default"])(_this, "handleClose", function () {
      _this.props.input.onBlur();
      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])(_this, "onChange", function (value) {
      _this.props.input.onFocus();
      _this.setState({
        value: value
      });
      var change = value !== null ? value.format(_this.props.format) : value;
      _this.props.input.onChange(change);
    });
    return _this;
  }
  (0, _inherits2["default"])(Time, _React$Component);
  return (0, _createClass2["default"])(Time, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.input.value) this.setState({
        value: formatTime(this.props.input.value, this.props.format)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var inputVal = this.props.input.value;
      if (prevProps.input.value !== inputVal && (!this.state.value || inputVal !== this.state.value.format(this.props.format))) {
        this.setState({
          value: formatTime(inputVal, this.props.format)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$meta = _this$props.meta,
        error = _this$props$meta.error,
        touched = _this$props$meta.touched,
        use12Hours = _this$props.use12Hours,
        format = _this$props.format,
        defaultValue = _this$props.defaultValue,
        disabledHours = _this$props.disabledHours,
        disabled = _this$props.disabled,
        placeholder = _this$props.placeholder,
        id = _this$props.id,
        required = _this$props.required,
        description = _this$props.description,
        labelStyle = _this$props.labelStyle;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Label, {
        required: required
      }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, this.props.label || this.props.smallLabel)), /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_timePicker["default"], (0, _extends2["default"])({
        showNow: false,
        needConfirm: false,
        defaultValue: (0, _moment["default"])(defaultValue, format),
        use12Hours: use12Hours,
        format: format,
        open: this.state.open,
        onOpenChange: this.handleOpenChange,
        onChange: this.onChange,
        disabledTime: disabledHours,
        disabled: disabled,
        placeholder: placeholder,
        id: id || "".concat(this.props.input.name, "_timepicker"),
        value: this.state.value,
        size: "large",
        pickerRef: null,
        locale: _objectSpread(_objectSpread({}, _en_US["default"]), {}, {
          lang: _objectSpread(_objectSpread({}, _en_US["default"].lang), {}, {
            ok: 'Ok'
          })
        })
      }, _lodash["default"].pick(this.props, timepicker_props)))), touched && error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), description && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        labelStyle: labelStyle,
        label: "".concat(description),
        style: {
          fontSize: "80%"
        }
      }));
    }
  }]);
}(_react["default"].Component);
Time.handlesErrorDisplay = true;
var timepicker_props = ['addon', 'allowClear', 'autoFocus', 'className', 'clearText', 'defaultOpenValue', 'disabled', 'disabledHours', 'disabledMinutes', 'disabledSeconds', 'format', 'getPopupContainer', 'hideDisabledOptions', 'hourStep', 'inputReadOnly', 'minuteStep', 'open', 'placeholder', 'popupClassName', 'popupStyle', 'secondStep', 'suffixIcon', 'clearIcon', 'use12Hours', 'value', 'onChange', 'onOpenChange'];
Time.defaultProps = {
  label: "",
  format: 'HH:mm',
  defaultValue: '00:00',
  meta: {},
  input: {},
  disabled: false,
  placeholder: 'Select time'
};
var _default = exports["default"] = Time;